import { useForm } from 'react-hook-form';

import useAppSelector from 'hooks/common/useAppSelector';
import { ApplicationFlag } from 'models/applications/enum';
import { selectCurrentApplication } from 'redux/selectors/staff/applications';

import { hideModal } from '../../redux/actions';
import { staffApplicationsApi } from '../../redux/api/staff/staff-applications-api';
import useAppDispatch from '../common/useAppDispatch';

type CreateExpertExamineReferralForm = {
  readonly hasIdentificationDocument: boolean;
  readonly hasEducationalDocument: boolean;
  readonly hasEducationGraduationDocuments?: boolean;
  readonly hasEducationDiploma?: boolean;
  readonly hasEducationalDocumentApplication: boolean;
  readonly hasEducationalDocumentsTranslation: boolean;
};

const useModeratorCreateExpertExaminationForm = (
  applicationId: number,
  postSubmit: Function
) => {
  const dispatch = useAppDispatch();
  const [sendToExpert, { isLoading }] =
    staffApplicationsApi.useSendApplicationToExpertMutation();

  const application = useAppSelector(selectCurrentApplication);

  const { register, handleSubmit, setValue, reset, getValues, ...rest } =
    useForm<CreateExpertExamineReferralForm>({
      defaultValues: {
        hasIdentificationDocument: false,
        hasEducationalDocument: false,
        hasEducationalDocumentApplication: false,
        hasEducationalDocumentsTranslation: false,
      },
    });

  const fields = {
    hasIdentificationDocument: register('hasIdentificationDocument'),
    hasEducationalDocument: register('hasEducationalDocument'),
    hasEducationGraduationDocuments: register(
      'hasEducationGraduationDocuments'
    ),
    hasEducationDiploma: register('hasEducationDiploma'),
    hasEducationalDocumentApplication: register(
      'hasEducationalDocumentApplication'
    ),
    hasEducationalDocumentsTranslation: register(
      'hasEducationalDocumentsTranslation'
    ),
  };

  const onSubmit = handleSubmit(data => {
    if (!application) return;
    const hasExpert = !!application.expertId;
    try {
      sendToExpert({
        applicationId: applicationId,
        request: {
          ...data,
          status: hasExpert
            ? ApplicationFlag.SENT_TO_EXPERT_AGAIN
            : ApplicationFlag.SENT_TO_EXPERT,
        },
      })
        .unwrap()
        .then(() => {
          postSubmit();
          dispatch(hideModal());
        });
    } catch (error) {
      console.error(error);
    }
  });

  return {
    fields,
    setValue,
    getValues,
    onSubmit,
    loading: isLoading,
    ...rest,
  };
};

export default useModeratorCreateExpertExaminationForm;
